/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { useEffect } from 'react';
import { TEventsMap, TMap } from './types';
import useImperativeComponentContext from './useImperativeIdentifierContext';

const useImperativeComponentEvents = <Events extends TMap = TMap>(
  handlers: Partial<TEventsMap<Events>>,
) => {
  const { id, eventsStore } = useImperativeComponentContext<Events>();

  useEffect(() => {
    Object.entries(handlers).forEach(([name, callback]) => {
      if (!eventsStore[id]) eventsStore[id] = {};
      if (!eventsStore[id][name])
        eventsStore[id][name as keyof typeof eventsStore[typeof id]] = [];

      eventsStore[id][name as keyof typeof eventsStore[typeof id]]?.push(
        callback,
      );
    });
    return () =>
      Object.entries(handlers).forEach(([name, callback]) => {
        eventsStore[id][name as keyof typeof eventsStore[typeof id]] = (
          eventsStore[id][name as keyof typeof eventsStore[typeof id]] ?? []
        ).filter((current) => current !== callback);
      });
  });
};

export default useImperativeComponentEvents;
